import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

export default function NotificationDetail() {
  const { id } = useParams();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`https://physiodirectory.in/api/notifications/${id}`)
      .then(res => {
        setNotification(res.data.notification || null);
      })
      .catch(() => setNotification(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="container-fluid px-3 pb-5 pt-3"><div className="text-center py-3">Loading...</div></div>;
  if (!notification) return <div className="container-fluid px-3 pb-5 pt-3"><h4 className="fw-semibold text-muted mb-2">Notification not found</h4></div>;

  return (
    <div className="container-fluid px-3 pb-5 pt-3">
      <div className="d-flex align-items-center mb-3">
        <Link to="/notifications" className="btn btn-link p-0 me-2" style={{fontSize: '1.5rem'}}><i className="bi bi-arrow-left"></i></Link>
        <h2 className="section-title mb-0">Notification Details</h2>
      </div>
      <div className="card h-100 shadow-sm border-0 notification-card-web">
        <div className="notification-image-wrapper" style={{height: '180px', overflow: 'hidden', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}}>
          <img src={notification.image ? notification.image : '/assets/notification-default.png'} alt={notification.title} style={{width: '100%', height: '100%', objectFit: 'cover', borderTopLeftRadius: '12px', borderTopRightRadius: '12px'}} onError={e => {e.target.onerror=null; e.target.src='/assets/notification-default.png';}} />
        </div>
        <div className="card-body p-3 d-flex flex-column">
          <h5 className="fw-bold mb-1" style={{ fontSize: '1.2rem', color: '#2d3748' }}>{notification.title}</h5>
          <div className="text-muted small mb-1">{notification.date}</div>
          <div className="mb-2">{notification.description}</div>
          {notification.file && (
            <button
              className="btn btn-outline-primary w-100 rounded-pill fw-semibold mt-2"
              style={{fontSize: '0.95rem'}}
              onClick={() => {
                if (window.ReactNativeWebView) {
                  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openExternal', url: notification.file }));
                } else {
                  window.open(notification.file, '_blank');
                }
              }}
            >
              Download File
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
